export const SHOW_ALL_FILTER = 'showAll' as const
